import './InfoWindow.css';
import React, { Component } from 'react';
import Airspaces, { ReferenceDatum, IcaoClass, AirspaceType } from '../../tools/Airspaces';

export default class InfoWindow extends Component {
    constructor(props) {
        super(props)
        this.map = this.props.map;
        this.state = {
            className: '',
            airspaceName: '',
            min: undefined,
            max: undefined,
            open: false,
            top : 50,
            left: 50,
        };
        this.airspace = {};
        this.eventListener();
    }

    eventListener() {
        window.addEventListener('airspaceInfoWindowOpen', (e) => {
            this.setState({ open: true });
            this.airspace = e.detail;
            this.getTooltipInfo(this.airspace);
            this.mouseMove();
        });

        window.addEventListener('airspaceInfoWindowClose', (e) => {
            this.setState({ open: false });
            this.props.onClose();
        });
    }

    mouseMove() {
        window.addEventListener('mousemove', (e) => {
            if(this.state.open) 
                this.setMousePosition(e);
        })
    }

    setMousePosition = (e) => {
        let top  = e.pageY;
        let left = e.pageX;
        this.setState({ top, left });
    }

    getTooltipInfo(airspace) {
        let min = Airspaces.getReadableLimit(airspace.lowerLimit);
        let max = Airspaces.getReadableLimit(airspace.upperLimit);
        let className = this.getCss(airspace);
        let airspaceName = Airspaces.getAirspaceName(airspace);
        this.setState({ className, airspaceName, max, min });
    }
    
    getCss (airspace) {
        // Class TODO Use the name of the class to avoid dupliclassNameing switches
        switch(airspace.icaoClass) {
            case IcaoClass.A:
                return 'classa';
            case IcaoClass.B:
                return 'classb';
            case IcaoClass.C:
                return 'classc';
            case IcaoClass.D:
                return 'classd';
        }

        // Danger / Prohibited / Restricted
        switch(airspace.type) {
            case AirspaceType.Danger:
                return 'danger';
            case AirspaceType.Prohibited:
                return 'prohibited';
            case AirspaceType.Restricted:
                return 'restricted';
        }

        return '';
    }

    render() {
        let { open } = this.props
        let { name } = this.airspace;
        let { className, airspaceName, max, min, top, left } = this.state;
        return (
            <div style={{ top, left}} className={open ? 'open' : ''} id="Airspace_tooltip" >
                <div className={className}>
                    <h1>{airspaceName}</h1>
                </div>
                <div className={className}>
                    <h1 className="sub">{name}</h1>
                </div>
                
                <div className="content">
                    <h2><span className="hr">{max}</span></h2>
                    <div className='line'></div>
                    <h2>{min}</h2>
                </div>
            </div>
        )
    }
}
